import { on, selectAll } from 'helpers/dom'

const selectors = {
  LINK_SELECTOR: '.link',
  LINK_HOVER_CLASS: 'link-hover'
}

document.onreadystatechange = function () {
  if (document.readyState === 'complete') {
    const linkEls = selectAll(selectors.LINK_SELECTOR)
    const timeout = window.innerWidth < 1024 ? 500 : 0

    if (linkEls.length) {
      linkEls.forEach(linkEl => {
        on('click', (event) => {
          if (linkEl.href) {
            event.preventDefault()
            linkEl.classList.add(selectors.LINK_HOVER_CLASS)

            setTimeout(() => {
              linkEl.classList.remove(selectors.LINK_HOVER_CLASS)
              window.location.href = linkEl.href
            }, timeout)
          }
        }, linkEl)
      })
    }
  }
}
